import { render, staticRenderFns } from "./info.vue?vue&type=template&id=3b81c0b8&"
import script from "./info.vue?vue&type=script&lang=js&"
export * from "./info.vue?vue&type=script&lang=js&"
import style0 from "./info.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/deploy/iot-product-tool/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b81c0b8')) {
      api.createRecord('3b81c0b8', component.options)
    } else {
      api.reload('3b81c0b8', component.options)
    }
    module.hot.accept("./info.vue?vue&type=template&id=3b81c0b8&", function () {
      api.rerender('3b81c0b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ryProbe/afterSale/info.vue"
export default component.exports